import { FC } from "react";
import { Accordion } from "@via/components/accordion/accordion";
import { classNames } from "@via/utils/helpers";

interface ApplySnippetPickerProps {
  snippets: string[];
  selectedIndex: number;
  onSelectIndex: (index: number) => void;
  onCancel: () => void;
  onApply: () => void;
}

export const ApplySnippetPicker: FC<ApplySnippetPickerProps> = ({
  snippets,
  selectedIndex,
  onSelectIndex,
  onCancel,
  onApply,
}) => {
  return (
    <div className="rounded-lg border border-indigo-200 bg-indigo-50/60 p-3">
      <div className="flex items-center justify-between gap-3">
        <div className="text-sm font-medium text-indigo-900">
          This reply contains multiple code snippets.
        </div>
        <button
          type="button"
          onClick={onCancel}
          className="text-sm font-medium text-indigo-700 hover:text-indigo-900 underline">
          Cancel
        </button>
      </div>

      <div className="mt-2 flex flex-wrap gap-2">
        {snippets.map((_, idx) => (
          <button
            key={idx}
            type="button"
            onClick={() => onSelectIndex(idx)}
            className={classNames(
              "rounded-full px-3 py-1 text-xs font-medium",
              idx === selectedIndex
                ? "bg-indigo-600 text-white"
                : "bg-white text-indigo-700 border border-indigo-200 hover:bg-indigo-50"
            )}>
            Snippet {idx + 1}
          </button>
        ))}
      </div>

      <div className="mt-3">
        <Accordion title="Snippet preview">
          <pre className="max-h-56 overflow-y-auto whitespace-pre-wrap break-words rounded-md bg-white p-3 text-xs font-mono text-gray-800 border border-indigo-100">
            {snippets[selectedIndex] ?? ""}
          </pre>
        </Accordion>
      </div>

      <div className="mt-3 flex justify-end">
        <button
          type="button"
          onClick={onApply}
          className="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500">
          Apply selected snippet
        </button>
      </div>
    </div>
  );
};
